/* tslint:disable */
/* eslint-disable */
/**
 * CheckFlow
 * CheckFlow
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCurrentStoreInfoViewModel
 */
export interface GetCurrentStoreInfoViewModel {
    /**
     * 
     * @type {number}
     * @memberof GetCurrentStoreInfoViewModel
     */
    storeId?: number;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentStoreInfoViewModel
     */
    storeName?: string | null;
}

/**
 * Check if a given object implements the GetCurrentStoreInfoViewModel interface.
 */
export function instanceOfGetCurrentStoreInfoViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetCurrentStoreInfoViewModelFromJSON(json: any): GetCurrentStoreInfoViewModel {
    return GetCurrentStoreInfoViewModelFromJSONTyped(json, false);
}

export function GetCurrentStoreInfoViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCurrentStoreInfoViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'storeId': !exists(json, 'storeId') ? undefined : json['storeId'],
        'storeName': !exists(json, 'storeName') ? undefined : json['storeName'],
    };
}

export function GetCurrentStoreInfoViewModelToJSON(value?: GetCurrentStoreInfoViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'storeId': value.storeId,
        'storeName': value.storeName,
    };
}

